import React, { useEffect, useState } from 'react';
export function UrgencyTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('urgency-timer-end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const end = Date.now() + 45 * 60 * 1000;
    sessionStorage.setItem('urgency-timer-end', end.toString());
    return 45 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-black" data-id="element-194">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-4 py-2.5 px-4" data-id="element-195">
        <span className="font-sans uppercase tracking-[0.2em] text-[10px] text-[#B9C2CF] pt-[15px] pb-[15px]" data-id="element-196">
          Oferta exclusiva de lanzamiento • Cupos de soporte limitados
        </span>
        <span className="font-sans text-gold tracking-[0.15em] text-[14px] pt-[10px] pb-[10px]" data-id="element-197">
          {pad(minutes)}:{pad(seconds)}
        </span>
      </div>
    </div>;
}